const normalizeBasePath = (basePath: string) => (
    basePath.endsWith('/') ? basePath : `${basePath}/`
);

export const getCenterHomePath = () => normalizeBasePath(import.meta.env.BASE_URL || '/');

export const redirectToCenterHome = () => {
    window.location.href = getCenterHomePath();
};
